import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
// css
import 'formiojs/dist/formio.full.css';
// custom import
import TemplateService from "../../../Services/TemplateService/TemplateService"
import { HandleApiError } from '../../../Utils/CommonErrors/HandleApiError';

const ViewTemplateLogs = () => {
  const { id } = useParams();
  const navigate = useNavigate()

  const [templateData, setTemplateData] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = useSelector(
    (state) => state.auth?.user?.data?.body?.data?.token
  );


  const getTemplate = async () => {
    try {
      const response = await TemplateService.getTemplateLogsById({ id }, token);
      const templateLog = response?.data?.body?.data;

      const formData = templateLog?.changes?.form_data;

      setTemplateData({
        action: templateLog?.action,
        performedBy: `${templateLog?.first_name || ""} ${templateLog?.last_name || ""}`,
        createdAt: templateLog?.createdAt,
        template_name:
          templateLog?.action === 'UPDATE'
            ? templateLog?.changes?.new?.template_name
            : templateLog?.action === 'DELETE'
              ? templateLog?.changes?.template_name
              : templateLog?.changes?.template_name,
        form_data: formData || null,
        fullChanges: templateLog?.changes
      });

      setLoading(false);
    } catch (error) {
      await HandleApiError(error);
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1); // Goes back one page in history
  };

  useEffect(() => {
    if (id) {
      getTemplate();
    }
  }, [id]);

  if (loading) {
    return <div className="main-inner-block">Loading...</div>;
  }

  return (
    <>
      <div className="main-inner-block">
        <div className='heading-content mt-3 mb-3'>
          <button
            className='green-btn back-button'
            onClick={handleBack}
          >
            <i className="fas fa-arrow-left" style={{ marginRight: '1px' }}></i>
            Back
          </button>
        </div>
        <div className="heading-content">Preview Template Logs</div>
        <div className="content">
          <div className="white-box">
            <div className="d-flex gap-3 create-user-block w-100 justify-content-between">
              <div className="row m-0 w-100">

                <div className="mb-3 col-lg-3 ps-0 padding-right">
                  <label className="form-label">Action</label>
                  <div className="form-input-block">
                    {templateData?.action || "-"}
                  </div>
                </div>

                <div className="mb-3 col-lg-3 padding-left">
                  <label className="form-label">Performed By</label>
                  <div className="form-input-block">
                    {templateData?.performedBy || "-"}
                  </div>
                </div>

                <div className="mb-3 col-lg-3 padding-left">
                  <label className="form-label">Created At</label>
                  <div className="form-input-block">
                    {templateData?.createdAt ? new Date(templateData.createdAt).toLocaleString() : "-"}
                  </div>
                </div>

                <div className="mb-3 col-lg-3 padding-left">
                  <label className="form-label">Template Name</label>
                  <div className="form-input-block">
                    {templateData?.template_name || "-"}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Optional debug panel */}
      <div className="main-inner-block">
        <div className="heading-content">Raw Changes</div>
        <div className="content">
          <div className="white-box" style={{ whiteSpace: 'pre-wrap' }}>
            <code>{JSON.stringify(templateData.fullChanges, null, 2)}</code>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewTemplateLogs;
